<div class="lv-artefact-container lv-component"
     [ngClass]="!!uiArtefakt?.Ausrichtung ? uiArtefakt?.Ausrichtung : uiAusrichtung">
  <div class="lv-fliesstext"
       [ngClass]="!!uiArtefakt?.TextAusrichtung ? uiArtefakt?.TextAusrichtung : textAusrichtung">
    <ng-container *ngIf="!!nestedSymbol && !!nestedSymbol.SymbolAlsPraefixJN">
      <mat-icon [ngClass]="[!!nestedSymbol?.SymbolGroesseInPixel ? nestedSymbol?.SymbolGroesseInPixel: '',
 !!nestedSymbol.SymbolFarbe ? nestedSymbol?.SymbolFarbe: '']" class="lv-fliesstext-symbol lv-symbol"
                [svgIcon]="nestedSymbol?.Symbolbezeichnung"></mat-icon>
    </ng-container>
    <span [innerHTML]="uiArtefakt.Text | lvHyphenationPipe"></span>
    <sup>&nbsp;</sup>
    <ng-container *ngIf="!!nestedSymbol && !nestedSymbol.SymbolAlsPraefixJN">
      <mat-icon [ngClass]="[!!nestedSymbol?.SymbolGroesseInPixel ? nestedSymbol?.SymbolGroesseInPixel: '',
 !!nestedSymbol.SymbolFarbe ? nestedSymbol?.SymbolFarbe: '']" class="lv-fliesstext-symbol lv-fliesstext-symbol-after lv-symbol"
                [svgIcon]="nestedSymbol?.Symbolbezeichnung"></mat-icon>
    </ng-container>
    <ng-container *ngIf="uiArtefakt.InfoTextTooltipCollapsable">
      <ng-container *ngIf="uiArtefakt.InfoTextTooltipCollapsableTyp === 'Tooltip'">
        <mat-icon *ngIf="mobile" [svgIcon]="'InfoCircle'" class="lv-info-icon"
                  (click)="onMobileClick()"></mat-icon>
        <mat-icon *ngIf="!mobile" [svgIcon]="'InfoCircle'" class="lv-info-icon"
                  matTooltipClass="lv-tooltip"
                  matTooltip="{{uiArtefakt.InfoTextTooltipCollapsable}}"
                  matTooltipPosition="above"></mat-icon>
      </ng-container>
      <ng-container *ngIf="uiArtefakt.InfoTextTooltipCollapsableTyp === 'Collapsable'">
        <mat-icon [svgIcon]="'InfoCircle'"
                  [ngClass]="{'lv-info-icon': true, 'open': showInfo}"
                  (click)="toggleInfo()"></mat-icon>
      </ng-container>
    </ng-container>
    <lv-info-text-tooltip-collapsable [showInfotext]="showInfo"
                                      [tooltip]="uiArtefakt.InfoTextTooltipCollapsable"
    ></lv-info-text-tooltip-collapsable>
    <lv-infotext-permanent
        [InfoTextPermanent]="uiArtefakt.InfoTextPermanent"></lv-infotext-permanent>
  </div>
</div>
